export class GetUsersResponse
{
    users: UserItem[];
}

export class UserItem
{
    userId: number;
    email: string;
    fullName: string;
    customerId?: number;
    customerName: string;
    userPhoneNumbers: { [id: number]: string};
}

export enum EmailRecipientTypeEnum {
    To = 1,
    Cc = 2,
    Bcc = 3
}